import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import Layout from "@/components/app/Layout";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";

export default function Signup() {
  const [form, setForm] = useState({ email: "", password: "", full_name: "", username: "" });
  const [loading, setLoading] = useState(false);
  const { signup } = useAuth();
  const nav = useNavigate();

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await signup(form);
      toast.success("Account created");
      nav("/dashboard");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Signup failed");
    } finally { setLoading(false); }
  };

  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const googleLogin = () => {
    const redirectUrl = window.location.origin + "/auth/callback";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <Layout>
      <section className="max-w-md mx-auto px-4 py-20">
        <h1 className="font-display text-3xl font-bold mb-2">Join Creative Hub</h1>
        <p className="text-sm text-muted-foreground mb-6">Create your free portfolio in seconds.</p>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label>Full name</Label>
            <Input required value={form.full_name} onChange={set("full_name")} data-testid="signup-fullname" />
          </div>
          <div>
            <Label>Username</Label>
            <Input required value={form.username} onChange={set("username")} placeholder="your-handle" data-testid="signup-username" />
            <div className="meta-label mt-1">Your profile URL: /u/{form.username || "your-handle"}</div>
          </div>
          <div>
            <Label>Email</Label>
            <Input type="email" required value={form.email} onChange={set("email")} data-testid="signup-email" />
          </div>
          <div>
            <Label>Password</Label>
            <Input type="password" required minLength={6} value={form.password} onChange={set("password")} data-testid="signup-password" />
          </div>
          <Button type="submit" className="w-full bg-[hsl(var(--accent))] hover:bg-[hsl(15_100%_55%)] text-white" disabled={loading} data-testid="signup-submit">
            {loading ? "Creating…" : "Create account"}
          </Button>
        </form>
        <div className="my-5 flex items-center gap-3 text-xs text-muted-foreground">
          <div className="h-px flex-1 bg-border" /> OR <div className="h-px flex-1 bg-border" />
        </div>
        <Button variant="outline" className="w-full" onClick={googleLogin} data-testid="google-signup-btn">Continue with Google</Button>
        <p className="mt-6 text-sm text-muted-foreground text-center">
          Already a member? <Link to="/login" className="text-foreground font-medium">Log in</Link>
        </p>
      </section>
    </Layout>
  );
}
